<template>
  <div class="container">
    <b-row>
      <b-col sm="12" class="float-right">
        <b-card>
          <b-button
            class="btn btn-lg float-right"
            type="submit"
            variant="primary"
            v-on:click="PrintSection"
          >
            <i class="fa icon-printer"></i> Cetak
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <div id="printSection">
      <!--
      <div class="bgWhite" style="height: 29.7cm; padding: 10mm 25mm 25mm 25mm">
      -->
      <div class="bgWhite" style="height: 33cm; padding: 10mm 25mm 25mm 25mm">
        <br />
        <div style="text-align:center">
          <div style="text-align: center">
            <img
              src="../assets/media/logoMara1.png"
              border="0"
              width="160"
              height="200"
            />
          </div>
        </div>
        <br />
        <div style="text-align:center">
          <h4 class="center">
            <strong>SLIP PENAWARAN</strong>
          </h4>
        </div>
        <div style="text-align:center">
          <h4 class="center">
            <strong>YOUNG TALENT DEVELOPMENT PROGRAMME (YTP)</strong>
          </h4>
        </div>
        <hr class="font-weight-bold" />
        <br />
        <table class="wrap-table d-flex justify-content-center mb-6" style="margin-left: 10%; width: 80%; border-collapse:separate; border-spacing: 0 1em;">
          <tbody>
            <tr style="vertical-align: top;">
              <td class="title">
                <span><strong>Nama</strong></span>
              </td>
              <td class="title">:</td>
              <td class="title">
                <span style="text-transform:uppercase">{{FirstName}}</span>
              </td>
            </tr>
            <tr style="vertical-align: top;">
              <td style="width:150px" class="title">
                <strong>No K/P</strong>
              </td>
              <td class="title">:</td>
              <td class="title">
                {{IdentityNo}}
              </td>
            </tr>
            <tr style="vertical-align: top;">
              <td class="title">
                <span><strong>Bil. MARA</strong></span>
              </td>
              <td class="title">:</td>
              <td class="title">
                {{AppStudentMaraNo}}
              </td>
            </tr>
            <tr style="vertical-align: top;">
              <td class="title">
                <span><strong>Kursus Ditawarkan</strong></span>
              </td>
              <td class="title">:</td>
              <td class="title">
                <span style="text-transform:uppercase">{{YTPCourseOfferName}}</span>
              </td>
            </tr>
            <tr style="vertical-align: top;">
              <td class="title">
                <span><strong>Institusi Persediaan</strong></span>
              </td>
              <td class="title">:</td>
              <td class="title">
                <span v-if="null!=Registration && 0<Registration.length" style="text-transform:uppercase; white-space: pre-line">{{Registration[0].InstitutionName}}</span>
              </td>
            </tr>
            <tr style="vertical-align: top;">
              <td class="title">
                <span><strong>Tempat Pendaftaran</strong></span>
              </td>
              <td class="title">:</td>
              <td class="title" style="text-align: left">
                <span v-if="null!=Registration && 0<Registration.length" style="text-transform:uppercase; white-space: pre-line">{{Registration[0].Venue}}</span>
              </td>
            </tr>
            <tr style="vertical-align: top;">
              <td class="title">
                <span><strong>Tarikh Pendaftaran</strong></span>
              </td>
              <td class="title">:</td>
              <td class="title">
                <span v-if="null!=Registration && 0<Registration.length" style="text-transform:uppercase">{{Registration[0].RegistrationDt | moment("DD/MM/YYYY")}}</span>
              </td>
            </tr>
            <tr style="vertical-align: top;">
              <td class="title">
                <span><strong>Hari Pendaftaran</strong></span>
              </td>
              <td class="title">:</td>
              <td class="title">
                <span v-if="null!=Registration && 0<Registration.length" style="text-transform:uppercase">{{getDay(Registration[0].RegistrationDt)}}</span>
              </td>
            </tr>
            <tr style="vertical-align: top;">
              <td class="title">
                <span><strong>Masa Pendaftaran</strong></span>
              </td>
              <td class="title">:</td>
              <td class="title">
                <span v-if="null!=Registration && 0<Registration.length" style="text-transform:uppercase">{{formatTime(Registration[0].RegistrationStartTime)}} - {{formatTime(Registration[0].RegistrationEndTime)}}</span>
              </td>
            </tr>
            <tr style="vertical-align: top;">
              <td style="width:200px; text-align:left;" class="title"><strong>No. Untuk Dihubungi Berkaitan Pendaftaran</strong></td>
              <td class="title">:</td>
              <td class="title" style="text-align: left">
                <span v-if="null!=Registration && 0<Registration.length" style="text-transform:uppercase; white-space: pre-line">{{Registration[0].ContactInformation}}</span>
              </td>
            </tr>
            <tr style="vertical-align: top;">
              <td class="title">
                <span><strong>Lain-lain Maklumat</strong></span>
              </td>
              <td class="title">:</td>
              <td class="title" style="text-align: left">
                <span v-if="null!=Registration && 0<Registration.length" style="text-transform:uppercase; white-space: pre-line">{{Registration[0].OtherInformation}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import Vue from "vue";

Vue.use(require("vue-moment"));
Vue.use(require("moment"));

export default {
  name: "slip-penawaran-ytp",
  components: {
  },
  props: ["appId", "programId"],
  data: function () {
    return {
      AllCourses: [],
      AllRegistrations: null,
      AppId: 0,
      AppStudentMaraNo: null,
      CourseOfferId: null,
      CourseAcademicLevels: [],
      FirstName: "",
      IdentityNo: "",
      Registration: null,
      RegistrationId: null,
      sCFN: 'SlipPenawaranYTP: ',
      YTPCourseOfferName: null,
    };
  },
  async mounted() {
    let fN = 'mounted: ';

    let isAuth = await this.UserAuth();
    if (isAuth) {
      await this.getPersonalDetails();
      await this.getAllCourses();
      await this.getAllRegistrations();
      await this.getProposedStudy();
      let courseSummary = await this.getTwinProgram(this.CourseOfferId);
      let courseAcademicLevels = await this.getTwinProgramDetails(this.CourseOfferId);
      this.CourseAcademicLevels = [];
      for (const item of courseAcademicLevels) {
        let courseDetail = await this.getInstitutionCourse(item.InstituteCourseDetailId);
        let obj = item;
        obj.CourseSummary = courseSummary;
        obj.CourseDetail = courseDetail;
        this.CourseAcademicLevels.push(obj);
      }
    }
  },
  computed: {
  },
  methods: {
    formatTime(time) {
      var formatted = this.moment(time, "HH:mm").format("hh:mm A");
      //console.log(formatted);
      //it will return 03:30 PM
      return formatted;
    },
    async getAllCourses() {
      let fN = 'getAllCourses: ';
      return this.$API
        .get(this.$GetAllTwinPrograms, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            //this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
            let arr = response.data;
            arr =  _.orderBy(arr, ['Sequence', 'Name'], ['asc', 'asc']);
            this.AllCourses = arr;
          }
        });
    },
    async getAllRegistrations() {
      let fN = 'getAllRegistrations: ';
      return this.$API
        .get(this.$AllRegistrationV4, { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            //this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
            let arr = _.orderBy(response.data, ['Name'], ['asc']);
            this.AllRegistrations = arr;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    getDay(dt) {
      if (null != dt)
        return this.moment(dt).locale("ms-my").format('dddd');
      return null;
    },
    async getInstitutionCourse(id) {
      return this.$API
      .get(this.$InstituteCourses + "/" + id, { withCredentials: true, })
      .then(response => {
        if (response.status == 200 && response.data != null) {
          return response.data;
        }
      })
      .catch(error => {
        console.log(error);
      });
    },
    async getPersonalDetails() {
      let fN = 'getPersonalDetails: ';
      return this.$API
        .get(this.$PersonalDetails, { withCredentials: true })
        .then((response) => {
          var info = response.data;
          if (response.status == 200 && info != null) {
            //this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
            this.AppId = info.AppId;
            this.IdentityNo = info.IdentityNo;
            this.FirstName = info.FirstName;
            this.AppStudentMaraNo = info.AppStudentMaraNo;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async getProposedStudy() {
      let fN = 'getProposedStudy: ';
      return this.$API
        .get(this.$ProposedStudy, { withCredentials: true })
        .then(async (response) => {
          var info = response.data;
          if (response.status == 200 && response.data != null) {
            this.CourseOfferId = info.YTPCourseOfferId;
            this.YTPCourseOfferName = info.YTPCourseOfferName;
            this.AppStudentMaraNo = info.AppStudentMaraNo;
            this.RegistrationId = info.RegistrationId;
            this.Registration = _.filter(this.AllRegistrations, ["Id", this.RegistrationId]);
            //this.HTECHLogger(this.sCFN + fN + 'this.RegistrationId = ' + this.RegistrationId + ' | this.Registration = ' + JSON.stringify(this.Registration))
            this.Registration[0].CourseOffered = response.data.Name;
            this.Registration[0].InstitutionName = null;
            let x = _.filter(this.AllCourses, ['InstituteId', this.Registration[0].InstitutionId]);
            if (0 < x.length) {
              this.Registration[0].InstitutionName = x[0].InstituteName;
            }
          } else {
            console.log(info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async getTwinProgram(twinProgramId) {
      return this.$API
        .get(this.$GetTwinProgram + "/" + twinProgramId, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            return response.data;
          }
        });
    },
    async getTwinProgramDetails(twinProgramId) {
      return this.$API
        .get(this.$GetTwinProgramDetails + "/" + twinProgramId, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            let InstitutionTwinAcademicPrograms = [];
            var arr = response.data;
            for (const item of arr) {
              InstitutionTwinAcademicPrograms.push(item);
            }
            return InstitutionTwinAcademicPrograms;
          }
        });
    },
    PrintSection() {
      this.$htmlToPaper("printSection");
    },
  },
};
</script>
<style scoped>
.title {
  font-size: 12pt;
}
</style>
